// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './address.model';
export * from './consent.model';
export * from './email.model';
export * from './file-dictionary.model';
export * from './settings.model';
export * from './status.model';
export * from './template.model';
export * from './unit-system.model';
export * from './upload-file.model';
export * from './view-mode';
// @endindex